// 引数として受け取った日付が2026/03/01以降であればtrueを返却
export const startDateCheck = (date: Date) => {
  const after = new Date("2026/03/01")
  return date >= after
}
